module.exports = __webpack_public_path__ + "static/media/select-map.8ac7a6a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/select-map.jpg
// module id = 682
// module chunks = 0